import React, { useEffect } from 'react';
import { useAuthStore } from '@/store/authStore';
import { RequestTabs } from './components/RequestTabs';
import { RequestDialog } from './components/RequestDialog';
import { PersonalInfoRequestDialog } from './components/PersonalInfoRequestDialog';
import { RejectConfirmDialog } from './components/RejectConfirmDialog';
import { useRequests } from './hooks/useRequests';
import { usePersonalInfoRequests } from './hooks/usePersonalInfoRequests';
import { useFamilyStore } from '@/store/familyStore';

export function Requests() {
  const { 
    requests, 
    selectedRequest, 
    rejectingRequestId,
    setSelectedRequest,
    setRejectingRequestId,
    handleApprove, 
    handleReject 
  } = useRequests();

  const {
    requests: personalInfoRequests,
    selectedRequest: selectedInfoRequest,
    rejectingRequestId: rejectingInfoRequestId,
    setSelectedRequest: setSelectedInfoRequest,
    setRejectingRequestId: setRejectingInfoRequestId,
    handleApprove: handleInfoApprove,
    handleReject: handleInfoReject
  } = usePersonalInfoRequests();

  const user = useAuthStore((state) => state.user);
  const fetchMembers = useFamilyStore((state) => state.fetchMembers);
  const fetchRequests = useFamilyStore((state) => state.fetchRequests);
  const isAdmin = user?.role === 'admin';

  // Fetch requests when component mounts
  useEffect(() => {
    fetchMembers();
    fetchRequests();
  }, [fetchMembers, fetchRequests]);

  return (
    <div className="h-full flex flex-col">
      <div className="flex-shrink-0">
        <h2 className="text-2xl font-bold text-gray-900 mb-6">الطلبات</h2>
      </div>

      <div className="flex-1 overflow-y-auto">
        <RequestTabs
          addRequests={requests}
          infoRequests={personalInfoRequests}
          isAdmin={isAdmin}
          onReviewAdd={setSelectedRequest}
          onRejectAdd={setRejectingRequestId}
          onReviewInfo={setSelectedInfoRequest}
          onRejectInfo={setRejectingInfoRequestId}
        />
      </div>

      {selectedRequest && (
        <RequestDialog
          request={selectedRequest}
          open={true}
          onClose={() => setSelectedRequest(null)}
          onApprove={handleApprove}
        />
      )}

      {selectedInfoRequest && (
        <PersonalInfoRequestDialog
          request={selectedInfoRequest}
          open={true}
          onClose={() => setSelectedInfoRequest(null)}
          onApprove={() => handleInfoApprove(selectedInfoRequest)}
          onReject={() => setRejectingInfoRequestId(selectedInfoRequest.id)}
        />
      )}

      {rejectingRequestId && (
        <RejectConfirmDialog
          open={true}
          onClose={() => setRejectingRequestId(null)}
          onConfirm={() => handleReject(rejectingRequestId)}
        />
      )}

      {rejectingInfoRequestId && (
        <RejectConfirmDialog
          open={true}
          onClose={() => setRejectingInfoRequestId(null)}
          onConfirm={() => handleInfoReject(rejectingInfoRequestId)}
        />
      )}
    </div>
  );
}